export let RolesStateKeys;
(function (RolesStateKeys) {
  RolesStateKeys["EDIT_ROLE_DIALOG"] = "editRoleDialog";
  RolesStateKeys["DELETE_ROLE_DIALOG"] = "deleteRoleDialog";
  RolesStateKeys["LOAD_ROLES"] = "loadRoles";
  RolesStateKeys["ADD_ROLE"] = "addRole";
  RolesStateKeys["MANAGE_PERMISSIONS"] = "managePermissions";
})(RolesStateKeys || (RolesStateKeys = {}));